var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        visible: _vm.open,
        overlayClassName: "no-padding archive-filter",
        placement: "bottom",
        trigger: "click",
      },
      on: {
        visibleChange: function (isVisible) {
          return (_vm.open = isVisible)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { width: "auto" },
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "filter-wrapper-form" }, [
            _c("div", { staticClass: "filter-wrapper-form-title" }, [
              _c(
                "span",
                {
                  staticClass: "material-icons closeIcon",
                  on: { click: _vm.close },
                },
                [_vm._v(" close ")]
              ),
              _vm._v(" "),
              _vm.type === "period"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" date_range "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "visitorId"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" fingerprint "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "conversationId"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" fingerprint "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "integration"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" public "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "storyId"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" schema "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "userIds"
                ? _c("span", { staticClass: "material-icons filterIcon" }, [
                    _vm._v(" badge "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "filterName ml-2" }, [
                _vm._v(
                  _vm._s(
                    {
                      period: this.$t("headBar.date"),
                      visitorId: "User ID",
                      conversationId: "Conversation ID",
                      integration: "Integration",
                      storyId: "Story",
                    }[_vm.type]
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.type === "period"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-story",
                        attrs: {
                          value: _vm.cloneValue,
                          placeholder: _vm.$t("chatbotv2.wholeTimeSpan"),
                          "filter-option": false,
                        },
                        on: { select: _vm.handleSelect },
                      },
                      _vm._l(_vm.periods, function (period) {
                        return _c(
                          "a-select-option",
                          {
                            key: period.value,
                            attrs: { value: period.value },
                            on: {
                              click: function () {
                                return _vm.selectOptionClick(period.value)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "blockTypeText" }, [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.time." + period.value))
                              ),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "visitorId"
              ? _c("div", { staticClass: "w-100 mb-3 row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-1" },
                    [_c("a-radio", { attrs: { checked: true } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-10 d-flex flex-column" },
                    [
                      _c("b", { staticClass: "row mx-2" }, [_vm._v("is")]),
                      _vm._v(" "),
                      _c("a-input", {
                        staticClass: "row",
                        attrs: { value: _vm.cloneValue },
                        on: {
                          blur: function ($event) {
                            return _vm.handleSelect($event.target.value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "conversationId"
              ? _c("div", { staticClass: "w-100 mb-3 row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-1" },
                    [_c("a-radio", { attrs: { checked: true } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-10 d-flex flex-column" },
                    [
                      _c("b", { staticClass: "row mx-2" }, [_vm._v("is")]),
                      _vm._v(" "),
                      _c("a-input", {
                        staticClass: "row",
                        attrs: { value: _vm.cloneValue },
                        on: {
                          blur: function ($event) {
                            return _vm.handleSelect($event.target.value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "integration"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-story",
                        attrs: {
                          value: _vm.cloneValue,
                          defaultValue: _vm.$t("chatbotv2.wholeIntegration"),
                          placeholder: _vm.$t("chatbotv2.wholeIntegration"),
                          "filter-option": false,
                        },
                        on: { select: _vm.handleSelect },
                      },
                      _vm._l(_vm.integrations, function (integration) {
                        return _c(
                          "a-select-option",
                          {
                            key: integration.value,
                            attrs: { value: integration.value },
                            on: {
                              click: function () {
                                return _vm.selectOptionClick(integration.value)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "blockTypeText" }, [
                              _vm._v(_vm._s(integration.name)),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "storyId"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-story",
                        attrs: {
                          value: _vm.cloneValue,
                          placeholder: _vm.$t("chatbotv2.wholeStoryIds"),
                          "filter-option": false,
                        },
                        on: { select: _vm.handleSelect },
                      },
                      _vm._l(_vm.stories, function (story) {
                        return _c(
                          "a-select-option",
                          {
                            key: story._id,
                            attrs: { value: story._id },
                            on: {
                              click: function () {
                                return _vm.selectOptionClick(story._id)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "blockTypeText" }, [
                              _vm._v(_vm._s(story.title)),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "userIds"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-story",
                        attrs: {
                          value: _vm.cloneValue,
                          defaultValue: _vm.$t("chatbotv2.wholeIntegration"),
                          placeholder: _vm.$t("chatbotv2.wholeIntegration"),
                          "filter-option": false,
                          mode: "multiple",
                        },
                        model: {
                          value: _vm.cloneValue,
                          callback: function ($$v) {
                            _vm.cloneValue = $$v
                          },
                          expression: "cloneValue",
                        },
                      },
                      _vm._l(_vm.users, function (user) {
                        return _c(
                          "a-select-option",
                          { key: user._id, attrs: { value: user._id } },
                          [
                            _c("span", { staticClass: "blockTypeText" }, [
                              _vm._v(_vm._s(user.name)),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "period" && _vm.cloneValue === "custom" && _vm.open
              ? _c(
                  "div",
                  { staticClass: "filter-content w-100" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        range: true,
                        "min-date": new Date().toDateString(),
                        color: "#faa566",
                        label: _vm.$t("wp.scheduleFuture"),
                        inline: true,
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                staticStyle: { "margin-top": "20px", width: "100%" },
              },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "d-block w-100",
                    attrs: { type: "primary", disabled: !_vm.isChanged() },
                    on: { click: _vm.saveValue },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.applyFilter")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-wrapper-preview" }, [
        _vm.type === "period"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" date_range "),
            ])
          : _vm.type === "integration"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" public "),
            ])
          : _vm.type === "story"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" smart_toy "),
            ])
          : _vm.type === "storyId"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" schema "),
            ])
          : _vm.type === "query"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" format_quote "),
            ])
          : _vm.type === "visitorId"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" fingerprint "),
            ])
          : _vm.type === "conversationId"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" fingerprint "),
            ])
          : _vm.type === "userIds"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" badge "),
            ])
          : _vm.type === "ignore"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" visibility_off "),
            ])
          : _vm.type === "userId"
          ? _c("span", { staticClass: "material-icons mainIcon" }, [
              _vm._v(" badge "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "material-icons closeIcon",
            on: { click: _vm.remove },
          },
          [_vm._v(" close ")]
        ),
        _vm._v(" "),
        _c("span", { attrs: { "text-truncate": "", "text-actions": "" } }, [
          _c("span", { attrs: { "text-weight": "semi-bold" } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.label))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }